export default __webpack_public_path__ + "static/media/banner-avatar.a5e74825.png";